import Cookies from "js-cookie";
import { superAdmins } from "../../config";
import { Navigate } from "react-router-dom";
const AdminGuard = ({ children }) => {
  const storedAddress = Cookies.get("connectedAddress");
  let isLoggedIn = false;
  superAdmins.forEach((admin) => {
    if (admin === storedAddress) {
      isLoggedIn = true;
    }
  });

  return isLoggedIn === true ? children : <Navigate to="/" replace />;
};
export default AdminGuard;
